import moment from 'moment';

export default () => ({
	regionSelecionada: null,
	notifyState: [
		{ state: 0, text: 'initial state', userText: 'Sin estado' },
		{ state: 1, text: 'accepted', userText: 'Aceptado' },
		{ state: 2, text: 'denied', userText: 'Denegado' },
		{ state: 3, text: 'pending', userText: 'Pendiente' },
		{ state: 4, text: 'registered', userText: 'Registrado' },
	],
	lodgingsOfPerson: [],
	selectedService: null,
	itemEmpty: null,
	lodgingWithProblems: null,
	message: '',
	updatingService: null,
	mirrorLodging: null,
	lodgingSelect: null,
	loadingLodgings: false,
	editMode: false,
	lodgings: [],
	periods: [],
	places: [],
	lodgingPersons: [],
	rangeDatePayments: {},
	lodgingsPlace: [],
	countLogingsPlace: 0,
	rangeDate: {
		start: null,
		end: null,
	},
	startSave: false,
	selectedPlace: null,
	servicesComboBox: [],
	bottomSheet: false,
	placeUsersEmails: [],
	updateMap: false,
	firma: '',
	firmaTecnico: '',
	lodgingForm: undefined,
	month: moment().format('YYYY-MM'),
	// Gestor de OT
	ordenes: [],
	totalOrdenes: 0,
	totalGeneralOrdenes: 0,
	kpisOrdenes: { total: 0, certificadas: 0, pendientes: 0, sinFirma: 0 },
	conteosOrdenesPorMes: {},
	loadingOrdenes: false,
	errorOrdenes: null,
	filtroOrdenes: {
		search: '',
		pagina: 1,
		cantidad: 25,
		orden: 'fecha',
		direccion: 'desc',
		mes: moment().format('YYYY-MM'),
		desde: '',
		hasta: '',
		estado: 'todas',
		tipos: [],
		persona: '',
		place: '',
	},
});
